import { Box } from '@mui/material'
import { CarrierType } from '@planning/app/api'
import { usePlanningStore } from '@planning/AppProvider'
import { Loader, useMinimalsTheme } from '@tom-ui/ui'
import { observer } from 'mobx-react-lite'
import { FC, useMemo } from 'react'
import { StepperForm } from './components/StepperForm/StepperForm'
import { StepperFormViewStore } from './components/StepperForm/StepperFormViewStore'
import { OrderReviewStore } from './components/StepperForm/stores/OrderReviewStore'
import {
  CreateOrderPageViewStore,
  isoCodeMappingFieldRenderFnType,
} from './stores/CreateOrderPageViewStore'
import { OrderFormStore } from './V2/stores/OrderFormStore'
import { CreateOrderPageHeader } from './V2/templates/CreateOrderPageHeader'

export interface ICreateOrderModalProps {
  inboundCarrierType?: CarrierType
  outboundCarrierType?: CarrierType
  outboundCarrierVisitId?: number | undefined
  onSubmit: (createdOrders?: { [key: string]: number }) => void
  onCancel: () => void
  isoCodeMappingFieldRenderFn?: isoCodeMappingFieldRenderFnType
  inheritedOperatorShortName?: string
}

export const CreateOrderModal: FC<ICreateOrderModalProps> = observer(
  ({
    inboundCarrierType,
    outboundCarrierType,
    outboundCarrierVisitId,
    onSubmit,
    onCancel,
    isoCodeMappingFieldRenderFn,
    inheritedOperatorShortName,
  }) => {
    const { appViewStore, containerItemStore } = usePlanningStore()
    const theme = useMinimalsTheme()

    const formStore = useMemo(() => new OrderFormStore(), [])
    const stepperFormViewStore = useMemo(() => new StepperFormViewStore(), [])
    const orderReviewStore = useMemo(() => new OrderReviewStore(), [])

    const createOrderPageViewStore = useMemo(
      () =>
        new CreateOrderPageViewStore(
          formStore,
          stepperFormViewStore,
          orderReviewStore,
          containerItemStore,
          isoCodeMappingFieldRenderFn,
          undefined,
          undefined,
          undefined,
          inheritedOperatorShortName,
        ),
      [
        formStore,
        stepperFormViewStore,
        orderReviewStore,
        containerItemStore,
        isoCodeMappingFieldRenderFn,
        inheritedOperatorShortName,
      ],
    )

    return (
      <>
        <Loader show={appViewStore.isLoading} />
        <CreateOrderPageHeader
          createOrderPageViewStore={createOrderPageViewStore}
          onSubmit={onSubmit}
          onBack={onCancel}
        />
        <Box
          paddingX={theme.customSpacing.l}
          paddingY={theme.customSpacing.m}
          gap={theme.customSpacing.m}
          display={'flex'}
          flexDirection={'column'}
          sx={{ background: theme.palette.background.neutral }}
          minHeight={'calc(100vh - 65px)'}
        >
          <StepperForm
            createOrderPageViewStore={createOrderPageViewStore}
            inboundCarrierType={inboundCarrierType}
            outboundCarrierType={outboundCarrierType}
            outboundCarrierVisitId={outboundCarrierVisitId}
          />
        </Box>
      </>
    )
  },
)
